module.exports = "<span data-ng-message=pattern> Only letters, numbers, and common characters (',', '.', ''', '-', '&','/') allowed </span> ";